import { ProfileSections } from "../types/types";
const DEFAULT_SOCIALS = {
    github: null,
    linkedIn: null,
    twitter: null,
    youtube: null,
    personal: null,
    repost: null,
    facebook: null,
    devto: null,
    blog: null,
};
export function getInitials(name) {
    if (!name)
        return "NA";
    const words = name.trim().split(/\s+/);
    const initials = words
        .slice(0, 2)
        .map((word) => word.charAt(0).toUpperCase())
        .join("");
    return initials;
}
export function getRadianAngle(degreeValue) {
    return (degreeValue * Math.PI) / 180;
}
export function rotateSize(width, height, rotation) {
    const rotRad = getRadianAngle(rotation);
    return {
        width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
    };
}
export const requiredLabel = (label, isRequired) => {
    return isRequired ? `${label} *` : label;
};
export const getOptionKey = (arr, value) => {
    if (!Array.isArray(arr) || Array.length === 0 || !value)
        return "";
    return arr.find((item) => item.value === value)?.key || "";
};
export const SocialMediaURIs = {
    github: "github.com/",
    facebook: "facebook.com/",
    linkedIn: "linkedin.com/in/",
    devto: "dev.to/",
    youtube: "youtube.com/",
    repost: "",
    blog: "",
    twitter: "x.com/",
};
export const normalizeURL = (url, baseURI) => {
    if (!url)
        return url;
    let cleanUrl = url.replace(/^(https?:\/\/)?(www\.)?/, "");
    if (!baseURI) {
        return cleanUrl;
    }
    if (cleanUrl.includes("/")) {
        if (cleanUrl.startsWith(baseURI) ||
            (cleanUrl.split("/")[0] !== baseURI.split("/")[0] &&
                !baseURI.endsWith("/"))) {
            return cleanUrl;
        }
        const path = cleanUrl.split("/").slice(1).join("/");
        return `${baseURI}${path}`;
    }
    return `${baseURI}${cleanUrl}`;
};
export const transformSocials = (socials) => {
    if (!socials)
        return DEFAULT_SOCIALS;
    return socials.reduce((acc, { option, input }) => {
        if (!option)
            return acc;
        if (option && input) {
            const key = toCamelCase(option);
            if (key in DEFAULT_SOCIALS) {
                if (key in SocialMediaURIs) {
                    acc[key] = normalizeURL(input, SocialMediaURIs[key]);
                }
                else {
                    acc[key] = input;
                }
            }
        }
        return acc;
    }, { ...DEFAULT_SOCIALS });
};
export const transformProfile = (profile) => {
    return {
        ...profile,
        socials: transformSocials(profile.socials),
        displayLocation: cleanDisplayLocation(profile.displayLocation),
    };
};
export const transformObjectToArray = (obj) => {
    return Object.entries(obj)
        .filter(([_, value]) => value !== null && value !== undefined && value !== "")
        .map(([key, value]) => ({
        option: key.charAt(0).toUpperCase() + key.slice(1),
        input: value,
    }));
};
export const cleanDisplayLocation = (displayLocation) => {
    const { countryRegion, stateProvince } = displayLocation;
    if (countryRegion === "") {
        return {
            countryRegion: null,
            stateProvince: null,
        };
    }
    return {
        countryRegion: countryRegion || null,
        stateProvince: stateProvince || null,
    };
};
export const toCamelCase = (key) => {
    if (!key)
        return;
    if (key.length === 0)
        return key;
    return key.charAt(0).toLowerCase() + key.slice(1);
};
export const hasError = (error, errorCode) => {
    if (!error || !error.extensions) {
        return false;
    }
    return error.extensions.code === errorCode;
};
export const hasMessageError = (error, message) => {
    if (!error || !error.message) {
        return false;
    }
    return error.message.includes(message);
};
export const isProfileValid = (profile) => {
    return Boolean(profile &&
        typeof profile === "object" &&
        !Array.isArray(profile) &&
        Object.keys(profile).length > 0);
};
export const validateVerificationCode = (code) => {
    const trimmedCode = code?.trim();
    if (!trimmedCode) {
        return {
            isValid: false,
            error: "Please enter a verification code.",
            isDirty: true,
        };
    }
    if (trimmedCode.length < 6) {
        return {
            isValid: false,
            error: "Verification code must be at least 6 characters",
            isDirty: true,
        };
    }
    return {
        isValid: true,
        error: null,
        isDirty: false,
    };
};
export const getSections = (sections) => {
    return {
        user: sections.includes(ProfileSections.User),
        emails: sections.includes(ProfileSections.Emails),
        community: sections.includes(ProfileSections.Community),
        interests: sections.includes(ProfileSections.Interests),
        work: sections.includes(ProfileSections.Work),
        communications: sections.includes(ProfileSections.Communications),
    };
};
//# sourceMappingURL=utils.js.map